export default __webpack_public_path__ + "static/media/canvasAndFramedA2Black.030ce747.jpg";